const BreedsRoutes = [
    {
      path: '/breeds',
      name: 'breeds',
      component: () => import('@/components/breeds/Breeds'),
    },
  
  //   {
  //     path: '/vaccine-templates/:id?',
  //     name: 'vaccine-template-details',
  //     component: () =>
  //         import('@/components/vaccineTemplates/VaccineTemplateDetails'),
  // },

    
  ];
  
  export default BreedsRoutes;
  